import classNames from "classnames";
import type { Property } from "csstype";
import { FC, ReactNode } from "react";
import styles from "./Inline.module.css";

type InlineProps = {
  children: ReactNode;
  columnGap?: number;
  justifyContent?: Property.JustifyContent;
  alignItems?: Property.AlignItems;
  flexWrap?: Property.FlexWrap;
  className?: string;
  onClick?: () => void;
};

const Inline: FC<InlineProps> = ({ children, columnGap, justifyContent, alignItems, flexWrap, className, onClick }) => {
  return (
    <div
      onClick={onClick}
      className={classNames(styles.inline, className)}
      style={{
        columnGap: columnGap + "rem",
        justifyContent: justifyContent,
        alignItems: alignItems,
        flexWrap: flexWrap,
      }}
    >
      {children}
    </div>
  );
};

export default Inline;
